import { useState } from "react";
import { Box, Button, Grid2 as Grid, Paper, Tooltip, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import useScreenSize from '../../../../hooks/useScreenSize';
import { Campaign } from "../../../../types/campaign";
import { MediaView } from "../../../../components/Shared/MediaView";
import { formatNumber } from "../../../../hooks/formatNumber";

type ImpressionsProps = {
    qualityImpressions: number,
    campaign: Campaign,
    size?: number
}

const QualityImpressionWidget = ({ qualityImpressions, campaign, size = 8 }: ImpressionsProps) => {
    const screenSize = useScreenSize();
    const [open, setOpen] = useState(false);

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ 
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 220,
                gap: 2
            }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="h6">Quality Impressions</Typography>
                    <Tooltip title={
                        <Typography variant="caption">
                            Impressions are considered quality when a user continues to look at the
                            ad for an extended period of time.
                        </Typography>
                    }>
                        <InfoOutlined fontSize="small" />
                    </Tooltip>
                </Box>
                <Grid container gap={2}>
                    <Grid size={12}>
                        <Typography>Campaign with Most Quality Impressions</Typography>
                        <Box display="flex" gap={1} justifyContent="space-between">
                            <Typography variant="h5">
                                {campaign.nickname} - {formatNumber(campaign.qualityImpressions ?? 0)}
                            </Typography>
                            {campaign.media.urls.length > 0 &&
                                <Button variant="contained" onClick={() => setOpen(true)}>View Media</Button>
                            }
                        </Box>
                    </Grid>
                    <Grid size={12}>
                        <Typography>Total Quality Impressions</Typography>
                        <Typography variant="h4">{formatNumber(qualityImpressions)}</Typography>
                    </Grid>
                </Grid>
                <MediaView title={campaign.title} urls={campaign.media.urls} open={open} setOpen={setOpen} />
            </Paper>
        </Grid>
    )
}

export default QualityImpressionWidget;
